<template>
  <v-container
    id="regular-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-account-box"
      inline
      class="px-5 py-3"
      title="Miembros Staff"
    >
      <template v-slot:after-title>
        <v-btn
          color="#ac8a2e"
          dark
          icon
          @click="goToNewStaffForm('new', 0)"
        >
          <v-icon
            large
            color="#ac8a2e"
          >
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="miembrosStaff"
        :search.sync="search"
        :sort-by="['fullName']"
        multi-sort
        @click:row="showItem"
      >
        <template
          v-if="$can('M_parametros')"
          v-slot:[`item.actions`]="{ item }"
        >
          <v-tooltip
            content-class="top"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="goToNewStaffForm('edit', item.id)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip
            content-class="top"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip
            content-class="top"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                v-on="on"
                @click.stop="sendResetPassword(item)"
              >
                mdi-email-alert
              </v-icon>
            </template>
            <span>Enviar restablecimiento de contraseña</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        search: undefined,
        headers: [
          { text: 'Apellido y nombre', align: 'start', sortable: true, value: 'fullName' },
          { text: 'Dni', value: 'user.dni' },
          { text: 'Fecha ingreso', value: 'fecha_ingreso' },
          { text: 'Cargo', value: 'cargo.descripcion' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        miembrosStaff: [],
        editedIndex: -1,
        menu: false,
        notificar: false,
        showNotificar: false,
        cargos: [],
        dataForm: {
          id: '',
          fecha_ingreso: '',
          cargo_id: '',
          cargo: {
            descripcion: '',
          },
          user: {
            id: '',
            dni: '',
            name: '',
            lastName: '',
            domicilio: '',
            celular: '',
            email: '',
            obs: '',
          },
        },
      }
    },
    computed: {
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
    },
    watch: {
      'dataForm.user.email' (val) {
        if (val === '') {
          this.showNotificar = false
        } else {
          this.showNotificar = true
        }
      },
      dialog (val) {
        val || this.close()
      },
    },
    created () {
      this.getMiembros()
      this.getCargos()
    },
    methods: {
      showItem (item) {
        this.goToNewStaffForm('show', item.id)
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/staff_delete/' + item.id + '/' + item.user.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Baja de staff exitosa'] })
          this.getMiembros()
        })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      getMiembros: async function () {
        this.$store.commit('loaderOn', 1)
        await this.$http.get('/api/staff_get',
        ).then(response => {
          this.miembrosStaff = response.data
        })
        this.$store.commit('loaderOff')
      },

      getCargos: async function () {
        await this.$http.get('/api/cargos_get',
                             {
                               headers: { Authorization: 'Bearer ' + this.$store.state.token },
                             },
        ).then(response => {
          this.cargos = response.data
        })
      },
      sendMailResetPassword: async function () {
        if (this.dataForm.user.email != null && this.dataForm.user.email !== '') {
          this.$store.dispatch('axiosMod/sendMailResetPassword', this.dataForm.user.email)
        } else {
          this.$store.commit('toast/show', { tipo: 'error', messages: ['El usuario debe tener un correo electrónico asociado'] })
        }
      },
      sendResetPassword: function (item) {
        this.editedIndex = this.miembrosStaff.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.sendMailResetPassword()
      },
      goToNewStaffForm: function (modeVal, idUser) {
        this.$router.push({ name: 'Alta Staff', params: { mode: modeVal, id: idUser } })
      },
    },
  }
</script>
